import { getSchoolYear } from "../../../mp-utils/generic-utils"
import { find } from "lodash"

export default function educatorStartModeTrigger(
  educatorStartMode,
  userObj,
  history,
  setState,
  initAssessment,
  userLicenses
) {
  const {
    settings: { assessmentId, subtestId }
  } = educatorStartMode
  const { assessments } = userObj
  const isLicensed = find(userLicenses, { licenseSet: assessmentId })

  if (!isLicensed || !educatorStartMode.settings) return

  let userAssessmentId = ""
  if (
    assessments &&
    assessments[assessmentId] &&
    assessments[assessmentId][getSchoolYear().year]
  ) {
    userAssessmentId =
      assessments[assessmentId][getSchoolYear().year].userAssessmentId
  }

  setState({ loadingAssessment: true })

  initAssessment(
    assessmentId,
    null,
    userObj,
    history.location,
    userAssessmentId || null,
    null,
    history,
    (err, userAssessment, user) => {
      if (err) {
        return setState({ loadingAssessment: false })
      }
      const { assessmentSet } = userAssessment

      let program = ""
      if (assessmentSet.name.includes("ACT")) {
        program = "act"
      }
      if (assessmentSet.name.includes("SAT")) {
        program = "sat"
      }
      if (assessmentSet.name.includes("PSAT")) {
        program = "psat"
      }
      if (assessmentSet.name.includes("STAAR")) {
        program = "staar"
      }

      history.push(
        `/truscore/practice-tests/${program}/test-taking/${assessmentId}/${subtestId}?item=1&a=${assessmentId}`
      )
      setState({ loadingAssessment: false })
    }
  )
}
